import {useParams} from 'react-router-dom';
import {useCurrentWorkspaceUrlPrefix} from '@tinct/core-workspace';
import {CampaignStudioView} from './campaign-studio-view';

/**
 * The customer app's studio route. Entered from the details page / settings
 * tab / per-variant Edit; exits back to the campaign instead of continuing a
 * "creation" flow. Publishing still goes through the funnel's publish step,
 * which owns quota checks and the launch confirmation.
 */
export function CampaignStudioPage() {
  const { id = '' } = useParams<{ id: string }>();
  const workspaceUrl = useCurrentWorkspaceUrlPrefix();

  return (
    <CampaignStudioView
      campaignId={id}
      backTo={`${workspaceUrl}/campaigns/${id}`}
      publishTo={`${workspaceUrl}/funnel-campaigns/${id}/publish`}
    />
  );
}
